import { render } from "./ButtonIcon.vue?vue&type=template&id=8e11329a&scoped=true&ts=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts"

import "./ButtonIcon.vue?vue&type=style&index=0&id=8e11329a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e11329a"]])

export default __exports__